var React = require('react');

function ResourceHubPost (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1267.242,793.623h-82.455l-155.95,308,238.219-.584Z","transform":"translate(-1028.838 -793.623)","fill":"#fff","opacity":"0.1"}));
}

ResourceHubPost.defaultProps = {"width":"238.405","height":"308","viewBox":"0 0 238.405 308"};

module.exports = ResourceHubPost;

ResourceHubPost.default = ResourceHubPost;
